export default __webpack_public_path__ + "static/swatches_b.6d43dd600a6c16c96ef6d7251a858912.png";